import { Apps } from '@/dtos'
import { captureEvent } from '@sentry/react'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { useApp } from './useApp'

export const useNavigateToUnauthorized = () => {
  const navigate = useNavigate()

  return useCallback((cause?: string) => {
    const message = `Unauthorized user tried to access the page.${cause && ` Cause: ${cause}`}`
    console.debug('useNavigateToUnauthorized', message)
    captureEvent({
      message,
      level: 'warning',
      extra: {
        'url': window.location.href
      }
    })

    navigate('/unauthorized')
  }, [navigate])
}

export const useNavigateToUnauthorizedBmw = (insuranceParamsId: string | undefined) => {
  const navigate = useNavigate()
  const { app, lastApp: { app: lastApp } } = useApp()

  return useCallback((cause?: string) => {
    const isLeasingSimplifiedWizard = app == Apps.leasingSimplifiedWizard || lastApp == Apps.leasingSimplifiedWizard
    if (!isLeasingSimplifiedWizard || !insuranceParamsId) return null

    const message = `Unauthorized user tried to access the page.${cause && ` Cause: ${cause}`}`
    console.debug('useNavigateToUnauthorizedBmw', message)
    captureEvent({
      message,
      level: 'warning',
      extra: {
        'url': window.location.href
      }
    })

    navigate(`/unauthorized/${insuranceParamsId}`)
  }, [navigate, app, lastApp, insuranceParamsId])
}

export const useNavigateToNotFound = () => {
  const navigate = useNavigate()

  return (cause?: string) => {
    captureEvent({
      message: 'User tried to access a non-existent page',
      level: 'warning',
      extra: {
        'url': window.location.href,
        'cause': cause
      }
    })

    navigate('/notfound')
  }
}